<template>
  <DetailsPageTitle :title="$t('static.careers.title')"> </DetailsPageTitle>
  <div class="auto-container flex-center-none flex-col gap-4 max-w-9/10">
    <h3 class="text-xl font-semibold">{{ $t('static.careers.header') }}</h3>
    <p class="text-base font-normal md:w-1/2 mx-auto mb-8">
      {{ $t('static.careers.subtitle') }}
    </p>

    <button
      class="btn-primary btn-hover w-1/3 mx-auto py-3 rounded-lg font-semibold"
    >
      <a href="mailto: jobs@taza.iq" target="_blank">
        {{ $t('static.careers.send_cv') }}
      </a>
    </button>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
